<template>
  <div :id="selector" class="glideClass">
      <div class="glide__track glide-track" data-glide-el="track">
        <ul class="glide__slides">
          <li v-for="(item,index) in band_list" :key="index" class="glide__slide">
            <BrandItem :item="item" class="brand-card"/>
          </li>
        </ul>
      </div>
      <div class="glide__arrows" data-glide-el="controls">
        <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
          <i class="ni ni-bold-left text-main-color"></i></button>
        <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
          <i class="ni ni-bold-right text-main-color"></i>
        </button>
      </div>
  </div>
</template>

<script>
import Glide from '@glidejs/glide'
import BrandItem from "@/views/components/elements/BrandItem";
import {generateUuidNo} from "@/util/helpers";

export default {
  name: "BandGlide",
  components: {
    BrandItem: BrandItem
  },
  props: {
    band_list: Array,
  },
  data() {
    return {
      selector: "",
      glide: null,
    };
  },
  created() {
    const randomNum = generateUuidNo();
    this.selector = `glide_${randomNum}`;
  },
  mounted() {
    this.mountGlide();
  },
  beforeDestroy() {
    if (this.glide) {
      this.glide.destroy();
      this.glide = null;
    }
  },
  methods: {
    mountGlide() {
      this.glide = new Glide(`#${this.selector}`, {
        type: 'carousel',
        startAt: 0,
        perView: 4,
        perMove: 1,
        autoplay: 3000,
        hoverpause: true,
        animationDuration: 500,
        breakpoints: {
          1199: {
            perView: 3,
          },
          991: {
            perView: 2,
          },
          767: {
            perView: 1,
          },
        },
      });
      this.glide.mount();
    },
  },
}
</script>

<style lang="scss" scoped>
.fit {
  object-fit: cover;
}

.glideClass {
  position: relative;
  padding: 0 2.5rem;
  box-sizing: border-box;
}

.glide-track {
  padding: 0;
  box-sizing: border-box;
}

.glide__slide {
  display: flex;
  justify-content: center;
}

.glide__arrows {
  pointer-events: none;
}

.glide__arrow {
  pointer-events: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}

.glide__arrow--left {
  left: 0.25rem;
}

.glide__arrow--right {
  right: 0.25rem;
}

.brand-card {
  width: 212px;
  height: 214px;
  flex: 0 0 auto;
}

@media (max-width: 991px) {
  .glideClass {
    padding: 0 1rem;
  }
}

@media (max-width: 575px) {
  .glideClass {
    padding: 0 0.5rem;
  }
}

</style>
